import { post } from '@/utils/network';

/**
 * 删除掉会话
 * @param params
 * @returns
 */
export const deleteSession = (params: { groupid: string;}) => {
    return post('/Instantmessaging/OperateApi/deleteSession', params)
}

export const shieldFriend = (params: { groupid: string;friendid: string;mute: number;}) => {
  return post('/Instantmessaging/OperateApi/shieldFriend', params)
}

export default {
    deleteSession,
    shieldFriend
};
